"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _BlogTags = _interopRequireDefault(require("../../components/Blog/BlogTags"));
var _BlogCard = _interopRequireDefault(require("../../components/Blog/BlogCard"));
var _richTextField = require("../../lib/richTextField");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A BlogList component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A BlogList
 */
function BlogListByCategory(props) {
  if (!props.renderingFields) return null;

  // Pulling blogs for certain category and structuring data
  var categoryList = props.renderingFields.CategoryList;
  var results = props.fields.blogs;
  var categorySet = [];
  var totalPosts = 0;
  var postsAdded = 0;
  if (results.length) {
    categoryList.forEach(eachItem => {
      categorySet.push({
        category: eachItem.fields.Category.value,
        title: eachItem.fields.Title.value,
        tagline: eachItem.fields.Tagline.value,
        count: eachItem.fields.BlogPostCount.value,
        linkText: eachItem.fields.LinkText.value,
        blogs: []
      });
      totalPosts += Number(eachItem.fields.BlogPostCount.value);
    });
    var i = 0;
    // loop through posts while we still have blogs to find or until we reach the end of all blogs
    var _loop = function _loop() {
      var blog = results[i];
      categorySet.forEach((item, index) => {
        if (blog.category === item.category && item.blogs.length < item.count) {
          categorySet[index].blogs.push(blog);
          postsAdded++;
        }
      });
      i++;
    };
    while (postsAdded < totalPosts || i >= results.length) {
      _loop();
    }
  }
  var TagList = (0, _lodash.map)(results, (eachItem, key) => {
    if (eachItem.topics.length > 0) {
      return (0, _lodash.map)(eachItem.topics, (tag, key) => {
        return tag;
      });
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing bloglist"
  }, categorySet.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, !(0, _lodash.isEmpty)(item.title) && /*#__PURE__*/_react.default.createElement("h2", {
      className: "mm-text-center blog-category-title"
    }, (0, _richTextField.parseHTML)({
      value: item.title
    })), !(0, _lodash.isEmpty)(item.tagline) && /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-text-center mm-spacing--minor blog-category-tagline"
    }, (0, _richTextField.parseHTML)({
      value: item.tagline
    })), !(0, _lodash.isEmpty)(item.blogs) && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, (0, _lodash.map)(item.blogs, (blog, key) => {
      // Need to restructure data from sitecore in the same fashion that the API returns data
      // as BlogCard expects the API response structure
      var structuredData = {
        authors: [],
        postDate: blog.postDate,
        url: blog.url,
        headline: blog.headline,
        blogThumbnail: blog.blogThumbnail,
        blogThumbnailAlt: blog.blogThumbnailAlt,
        overview: blog.overview
      };
      blog.authors.forEach(author => {
        structuredData.authors.push({
          url: author.url,
          name: author.name
        });
      });
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
        className: "align-self-stretch",
        lg: 4,
        sm: 12,
        key: key
      }, /*#__PURE__*/_react.default.createElement(_BlogCard.default, {
        item: structuredData,
        id: key,
        hideDate: false
      }));
    })), !(0, _lodash.isEmpty)(item.linkText) && /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-text-center blog-category-link"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "/".concat(item.category.replace(/\s+/g, '-').toLowerCase())
    }, (0, _richTextField.parseHTML)({
      value: item.linkText
    }))));
  }), /*#__PURE__*/_react.default.createElement(_BlogTags.default, {
    className: "blog-home-tags",
    tags: TagList.flat()
  }));
}
var _default = exports.default = BlogListByCategory;